import { combineReducers } from 'redux'

import modal from '../common/Modal/store/reducer'
import auth from '../modules/auth/store/reducer'
import setup from '../modules/setup/store/reducer'
import dashboard from '../modules/dashboard/store/reducer'

export default combineReducers({ modal, auth, setup, dashboard })
